import React from "react";
import { markdown } from "markdown";

export default ({
  buttonImage,
  buttonText,
  buttonLink,
  externalLink,
  attachment,
  heading,
  includeButton,
  textContent: { textContent },
  backgroundImage: {
    file: { url }
  },
  convertToBlackWhite
}) => (
  <li
    style={{
      backgroundImage: `url(${url})`,
      filter: convertToBlackWhite ? "saturate(0)" : null
    }}
  >
    <div className="overlay" />
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
          <div className="slider-text-inner js-fullheight">
            <div className="desc">
              <h1>{heading}</h1>
              <h2
                dangerouslySetInnerHTML={{
                  __html: markdown.toHTML(textContent)
                }}
              />
              <p>
                {includeButton ? (
                  <a
                    className="btn btn-primary btn-learn"
                    href={
                      attachment
                        ? attachment.file.url
                        : buttonLink
                          ? `#${buttonLink.replace(/[^a-zA-Z0-9]/, "-")}`
                          : externalLink
                            ? externalLink
                            : null
                    }
                  >
                    {buttonText} <i className={`icon-${buttonImage}`} />{" "}
                  </a>
                ) : (
                  ""
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/slide.js